
import { AuthPayload } from '@/interfaces/ui.interface'
import api from '@/plugins/axios'

export default {
  async fetchCatalogo({ commit }: any) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: false
    }
    try {
      const response = await api.get('/catalogo')
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion consultada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al eliminar: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setCatalogo', payload)
    }
  },
  async getTiposEvento({ commit }: any) {
      const payload: AuthPayload = {
        data: null,
        success: false,
        message: '',
        show: false
      }
    try {
      const response = await api.get('/tipos-evento')
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion consultada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al eliminar: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setTiposEvento', payload)
    }
  },
  async getOpcionesCotizacionList({ commit }: any, filters: any = {}) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: false
    }
    try {
      const response = await api.get('/cotizacion/opciones-cotizaciones', { params: filters })
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion consultada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al eliminar: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setOpcionesCotizacionList', payload)
    }
  },
  async createCotizacionConOpciones({ commit }: any, data: any) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: false
    }
    try {
      const response = await api.post('/cotizaciones/opciones-cotizacion', data)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion consultada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al eliminar: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setResult', payload)
    }
  },
  async getOpcionCotizacionDetails({ commit }: any, id: number) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: false
    }
    try {
      const response = await api.get(`/cotizacion/opciones-cotizacion/details/${id}`)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion consultada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al obtener opciones de cotizacion: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setOpcionCotizacionDetails', payload)
    }
  },
  async deleteCotizacion({ commit }: any, id: number) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    }
    try {
      const response = await api.delete(`/cotizacion/opciones-cotizacion/${id}`)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Cotización eliminada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al eliminar cotización: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setResult', payload)
    }
  },
  async fetchCotizaciones({ commit }: any, search: any) {
      const payload: AuthPayload = {
        data: null,
        success: false,
        message: '',
        show: false
      }
    try {
      const response = await api.get('/cotizaciones', {
        params: search.params
      })
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion consultada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al obtener cotizaciones: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setCotizaciones', payload)
    }
  },
  async createCotizacion({ commit }: any, cotizacion: any) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    }
    try {
      const response = await api.post('/cotizaciones', cotizacion)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Cotizacion creada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al crear cotizacion: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setResult', payload)
    }
  },
  async agregarAbono({ commit }: any, abono: any) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    } 
    try {
      const response = await api.post(`/cotizaciones/${abono.cotizacionID}/abonos`, abono.abonos)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Abono agregado con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al agregar abono: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setResult', payload)
    }
  },
  async eliminarAbono({ commit }: any, abono: any) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    }
    try {
      const response = await api.delete(`/abonos/${abono.AbonoID}`)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Abono eliminado con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al eliminar abono: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setResult', payload)
    }
  },
    async fetchObtenerCotizacion({commit}: any, id: number) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: false
    }
    try {
      const response = await api.get(`/cotizaciones/${id}`)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Informacion consultada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al obtener cotizacion: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setCotizacion', payload)
    }
  },
  async eliminarOpcionCotizacion ({ commit }: any, opcion: any) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    }
    try {
      const response = await api.delete(`/cotizacion/opciones-cotizacion/${opcion.OpcionCotizacionID}`)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Opcion eliminada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al eliminar cotizacion: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setResult', payload)
    }
  },
  async crearServicioCompletoTransaccional ({ commit }: any, servicio: any) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    }
    try {
      const response = await api.post('/servicios/completo', servicio)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Servicio creado con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al crear servicio: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setResult', payload)
    }
  },
  async actualizarServicioCompletoTransaccional ({ commit }: any, data: any) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    }
    try {
      const response = await api.put(`/servicios/${data.servicio.ServicioID}/transaccional`, data)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Servicio actualizado con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al actualizar servicio: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setResult', payload)
    }
  },
  async eliminarServicioCompletoTransaccional ({ commit }: any, servicio: any) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    }
    try {
      const response = await api.delete(`/servicios/${servicio.ServicioID}/transaccional`)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Servicio eliminado con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al eliminar servicio: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setResult', payload)
    }
  },
  async eliminarCotizacion ({ commit }: any, cotizacion: any) {
    const payload: AuthPayload = {
      data: null,
      success: false,
      message: '',
      show: true
    } 
    try {
      const response = await api.delete(`/cotizacion/${cotizacion.CotizacionID}`)
      if (response.data) {
        payload.data = response.data
        payload.success = true
        payload.message = 'Cotizacion eliminada con éxito'
      } else {
        payload.message = 'Respuesta inesperada del servidor'
      }
    } catch (error: any) {
      payload.data = error
      payload.message = (!error.response)
        ? 'No se pudo conectar al servidor...'
        : `Error al eliminar cotizacion: ${error.response.data?.message || 'Error desconocido'}`
    } finally {
      commit('Ui/setSnackbar', {
        text: payload.message,
        color: (payload.success) ? 'success' : 'error',
        show: payload.show
      }, { root: true })
      commit('setResult', payload)
    }
  }
}
